import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDocsIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={14}
    fill="none"
    viewBox="0 0 13 14"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.2}
      d="M11.052 1.344H2.257C1.563 1.344 1 1.906 1 2.6v8.796c0 .694.563 1.256 1.257 1.256h8.795c.694 0 1.257-.562 1.257-1.256V2.6c0-.694-.563-1.256-1.257-1.256M3.514 3.86h6.282M3.514 7h6.282M3.514 10.14h3.77"
    />
  </svg>
);
export default SvgDocsIcon;
